import { fetchPortfolioCollections } from './fetch-portfolio-collections';
export const fetchPortfolio = async (httpClient, errorHandler, ids) => {
  const portfolioCollections = [];
  const collections = await fetchPortfolioCollections(httpClient, errorHandler, ids);
  const collectionResults = collections.filter(collection => Boolean(collection.id));
  portfolioCollections.push(...collectionResults);
  return portfolioCollections;
};
//# sourceMappingURL=fetch-portfolio.js.map